module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-color-svpanel",
    style: ({
      backgroundColor: _vm.background
    })
  }, [_c('div', {
    staticClass: "el-color-svpanel__white"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-color-svpanel__black"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-color-svpanel__cursor",
    style: ({
      top: _vm.cursorTop + 'px',
      left: _vm.cursorLeft + 'px'
    })
  }, [_c('div')])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65c5c78e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/qfpay-element-ui/packages/color-picker/src/components/sv-panel.vue
// module id = 827
// module chunks = 1